import { Controller } from "stimulus"
import { showTarget, hideTarget } from '../helpers/visibility'

export default class extends Controller {
  static targets = ["checkbox", "expenseGroupIdField", "bulkUpdateControls"]

  connect() {
    this.update()
  }

  update() {
    if(this.hasExpenseGroupIdFieldTarget) {
      const checked = this.checkboxTargets.filter(c => c.checked)
      const expenseGroupIds = checked.map(checkbox => checkbox.value)
      this.expenseGroupIdFieldTargets.forEach(target => {
        target.value = expenseGroupIds.join(",")
      })

      if(expenseGroupIds.length) {
        showTarget(this.bulkUpdateControlsTarget)
      }
      else {
        hideTarget(this.bulkUpdateControlsTarget)
      }
    }
    else {
      this.hideAllCheckboxes()
    }
  }

  hideAllCheckboxes() {
    hideTarget(this.checkboxTargets)
  }
}

